export default "__VITE_ASSET__6JKshTcg__"